import { useDispatch, useSelector } from 'react-redux';
import { profileActions } from '../../../di/di';
import { useNavigate } from 'react-router-dom';
import { LoginRoute } from '../../../../../core/routes/route_constants';

const LogoutModalComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showLogoutModal = useSelector((state) => state.profile.showLogoutModal);
    
    const handleLogout = () => {
        dispatch(profileActions.logout());
        navigate(LoginRoute);
        dispatch(profileActions.setShowLogoutModal(false));
    }

    const handleOnClose = () => {
        dispatch(profileActions.setShowLogoutModal(false));
    }

    if (!showLogoutModal) return null;

    return (
        <div className="fixed lg:ml-[15rem] inset-0 flex items-center justify-center bg-black bg-opacity-70">
            <div 
                className="bg-gradient-to-b from-slate-950 to-fuchsia-950/80 border border-red-900/30 rounded-xl p-6 w-full max-w-md mx-4 animate-fade-in"
            >
                <h3 className="text-xl font-bold text-pink-200 mb-4">Confirm Logout</h3>
                <div className="mb-6">
                    <p className="text-base text-pink-300">Are you sure you want to log out of your account?</p>
                </div>
                <div className="flex justify-end space-x-3">
                    <button 
                        onClick={handleOnClose}
                        className="text-base px-4 py-2 text-white bg-slate-900/70 rounded-md hover:bg-red-900/40 transition-colors active:translate-y-0.5 active:shadow-none"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={handleLogout} 
                        className="text-base px-4 py-2 text-white bg-gradient-to-r from-red-800 via-red-900 to-red-950 rounded-md hover:opacity-90 transition-all active:translate-y-0.5 active:shadow-none"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
}

export default LogoutModalComponent;